import {
  FileHandlerCreator,
  FileKey,
  createFileHandler,
} from './FileHandlerConfig';

/**
 * No-op file handler that immediately succeeds without uploading.
 * Used for free users to mock a file upload in the UI without making API calls.
 */
export const createNoOpHandler: FileHandlerCreator<FileKey> = createFileHandler(
  ({ onSuccess }) => {
    return async ({ file }) => {
      const mockFileKey = `mock-file-key-${Date.now()}`;
      onSuccess({ type: 'fileKey' as const, fileKey: mockFileKey, file });
    };
  }
);
